import _extends from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/extends.js";
import _taggedTemplateLiteral from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
import _objectWithoutProperties from "/workdir/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";

var _templateObject;

var _excluded = ["tags", "value", "prefixIcon", "prefixIconColour", "iconRatio", "required", "disabled", "placeholder", "onRemoveTag", "labelText", "containerProps"];
import React, { useState } from "react";
import { css } from "@catchoftheday/theme";
import { Box } from "../Box";
import { Flex } from "../Flex";
import { Input } from "../Input";
import { Tag } from "../Tag";
import { jsx as ___EmotionJSX } from "@emotion/react";
export var TaggedInput = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$tags = _ref.tags,
      tags = _ref$tags === void 0 ? [] : _ref$tags,
      value = _ref.value,
      PrefixIcon = _ref.prefixIcon,
      prefixIconColour = _ref.prefixIconColour,
      iconRatio = _ref.iconRatio,
      _ref$required = _ref.required,
      required = _ref$required === void 0 ? false : _ref$required,
      _ref$disabled = _ref.disabled,
      disabled = _ref$disabled === void 0 ? false : _ref$disabled,
      _ref$placeholder = _ref.placeholder,
      placeholder = _ref$placeholder === void 0 ? "Search" : _ref$placeholder,
      onRemoveTag = _ref.onRemoveTag,
      _ref$labelText = _ref.labelText,
      labelText = _ref$labelText === void 0 ? "Search" : _ref$labelText,
      containerProps = _ref.containerProps,
      inputProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = useState(false),
      isFocused = _useState[0],
      setFocused = _useState[1];

  return ___EmotionJSX(Flex, _extends({
    p: 1,
    mx: "16px",
    alignItems: "center",
    flexWrap: "wrap",
    border: 1,
    borderRadius: "default",
    borderColor: isFocused ? "secondary" : "ui.borderColor",
    css: css(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n          transition: border-color 0.2s ease;\n        "])))
  }, containerProps), PrefixIcon && ___EmotionJSX(PrefixIcon, {
    height: "2em",
    width: "".concat(2 * (iconRatio || 0.5), "em"),
    mx: 2,
    color: disabled ? "typography.inactive" : prefixIconColour || "inherit",
    role: "img"
  }), tags.map(function (tag) {
    return ___EmotionJSX(Tag, {
      key: tag.id,
      disabled: tag.disabled,
      onClick: function onClick() {
        return onRemoveTag && tag.id && onRemoveTag(tag.id);
      },
      backgroundColor: tag.colour,
      "data-testid": "tag-".concat(tag.id)
    }, tag.text);
  }), ___EmotionJSX(Box, {
    flexGrow: 1,
    flexShrink: 0,
    width: "50%"
  }, ___EmotionJSX(Input, _extends({
    ref: ref,
    value: value,
    placeholder: placeholder,
    disabled: disabled,
    maxLength: 15,
    required: required,
    border: "none",
    p: 2,
    "aria-label": labelText,
    width: "100%"
  }, inputProps, {
    onFocus: function onFocus(e) {
      if (typeof (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onFocus) === "function") {
        inputProps.onFocus(e);
      }

      setFocused(true);
    },
    onBlur: function onBlur(e) {
      if (typeof (inputProps === null || inputProps === void 0 ? void 0 : inputProps.onBlur) === "function") {
        inputProps.onBlur(e);
      }

      setFocused(false);
    },
    autoComplete: "off"
  }))));
});
TaggedInput.displayName = "TaggedInput";
export default TaggedInput;